import _ from "lodash";
import React from "react";
import classes from "./LoadingDots.scss";

const LoadingDots = props => {
  const { numberOfDots = 3, loadingDotsStyle = {} } = props;

  return (
    <span className={classes.loader}>
      {_.map(_.range(numberOfDots), (__, index) => (
        <span
          className={classes.loadingDot}
          style={{
            animationDelay: `${index * 0.2}s`,
            ...loadingDotsStyle,
          }}
          key={index}
        >
          &#8226;&#160;
        </span>
      ))}
    </span>
  );
};

export default LoadingDots;
